import {Button} from '@wandb/weave/components/Button';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {FC} from 'react';

import {DatasetInfo} from '../hooks/useLeaderboardComparison';
import {CompareEvaluationsDropdownButton} from './CompareEvaluationsDropdownButton';

interface CompareEvaluationsControlBarProps {
  entity: string;
  project: string;
  selectedEvaluations: string[];
  selectedModelsCount: number;
  availableDatasets: DatasetInfo[];
  loading: boolean;
  onClearSelection: () => void;
  onDatasetSelect: (datasetFullName: string) => void;
}

export const CompareEvaluationsControlBar: FC<
  CompareEvaluationsControlBarProps
> = ({
  entity,
  project,
  selectedEvaluations,
  selectedModelsCount,
  availableDatasets,
  loading,
  onClearSelection,
  onDatasetSelect,
}) => {
  if (selectedEvaluations.length === 0) {
    return null;
  }

  return (
    <Tailwind>
      <div className="bg-gray-50 flex items-center gap-8 border-b border-moon-250 px-16 py-8">
        <Button
          variant="ghost"
          size="small"
          icon="close"
          onClick={onClearSelection}
          tooltip="Clear selection"
        />
        <div className="text-sm">
          {selectedModelsCount} {selectedModelsCount === 1 ? 'model' : 'models'}{' '}
          selected:
        </div>
        <CompareEvaluationsDropdownButton
          entity={entity}
          project={project}
          selectedEvaluations={selectedEvaluations}
          onDatasetSelect={onDatasetSelect}
          availableDatasets={availableDatasets}
          loading={loading}
          disabled={selectedEvaluations.length === 0}
        />
      </div>
    </Tailwind>
  );
};
